<script>
import {mapState} from "vuex";
import Loading from "@/components/Loading";
import PageHeader from "@/components/page-header";
import {createWithdrawal} from "@/api/transaction";
import {checkTwoFactor} from "@/api/auth";
import * as _ from 'lodash';
import crypto from 'crypto';
import {getSites, getSite} from "@/api/sites";

export default {
  components: {PageHeader, Loading},
  data() {
    return {
      loading: false,
      title: "Çekim Talebi Oluştur",
      items: [
        {
          text: "Para Çekme",
          href: "/withdrawals"
        },
        {
          text: "Çekim Talebi Oluştur",
          active: true
        }
      ],
      sites: [],
      selectedSite: null,
      site: {
        id: null,
        appKey: null,
        appSecret: null,
      },
      form: {
        amount: null,
        userId: null,
        name: null,
        userName: null,
        accountName: null,
        iban: null,
        processId: null,
      },
      signature: null,
      twoFaKey: null,
      parseInput: null,
      parseInputInter: null,
      extraBetMode: false,
      interMode: false,
    };
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
      user: state => state.auth.user,
    }),
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          this.form.amount = this.form.amount.replace(",", ".");
          this.form.bankId = this.config.defaultBankId;
          this.form.createdBy = this.user.username;
          this.form.manual = 1;
          this.signature = this.createSignature();
          createWithdrawal(this.signature, this.site.appKey, this.form).then((response) => {
            const status = _.get(response, "data.data.status");
            if (status === "bankAccount_not_found") {
              alert("Banka hesabı bulunamadı. Lütfen daha sonra tekrar deneyiniz.");
            }
            if (status === "error_invalid_sign" || status === "error_invalid_bank") {
              alert("İşlem hatası oluştu. Lütfen daha sonra tekrar deneyiniz.");
            }
            if (status === "pending") {
              this.$bvToast.toast("Çekim talebiniz başarıyla oluşturulmuştur.", {
                title: "Başarılı!",
                variant: 'success',
                solid: true
              });
              this.$router.push('/withdrawals');

            }
            this.loading = false;
            this.form = {
              amount: null,
              userId: null,
              name: null,
              userName: null,
              accountName: null,
              iban: null,
              processId: null,
            };
          });
        }
      });
    },
    validateTwoFactor() {
      checkTwoFactor({userId: String(this.user.id), twoFaToken: this.twoFaKey}).then((response) => {
        if (response.status === 200) {
          this.submitForm();
        }
      })
    },
    setProcessId() {
      this.form.processId = Math.random().toString().slice(2, 15) + Math.random().toString().slice(2, 5);
    },
    handleCreateWithdraw() {
      if (this.user.enableTwoFactor && !this.site.skip2FaForTransaction) {
        this.$bvModal.show('twofa-modal');
      } else {
        this.submitForm();
      }
    },
    renderTypes() {
      const types = [];
      this.config.integrations.forEach((c) => {
        types.push({
          key: c.charAt(0).toUpperCase() + c.slice(1),
          value: c
        });
      });
      return types;
    },
    createSignature() {
      const encodedRequest = new URLSearchParams(this.form).toString();
      return crypto.createHmac("sha256", this.site.appSecret).update(encodedRequest).digest().toString('base64');
    },
    parseText() {
      if (this.parseInput || this.parseInput !== '') {
        this.parseInput = this.parseInput.trim();
        try {
          const splitted = this.parseInput.split("Papara Üye Numarası");
          let amount = splitted[0].replace("₺", "").trim();
          amount = amount.replace(",", "").trim();
          const splitted2 = splitted[1].split(", Papara Numarasi:");

          const nameSurname = splitted2[0].trim();
          const paparaNo = splitted2[1].trim();

          this.form.amount = amount;
          this.form.name = nameSurname;
          this.form.accountName = nameSurname;
          this.form.iban = paparaNo;
          this.form.userId = paparaNo;
          this.form.userName = this.toSeoUrl(nameSurname);
        } catch (e) {
          console.log("parse error");
          this.form = {
            amount: null,
            userId: null,
            name: null,
            userName: null,
            accountName: null,
            iban: null,
          };
        }
      }
    },
    parseTextInter() {
      if (this.parseInputInter || this.parseInputInter !== '') {
        try {
          let text = this.parseInputInter.replace(/\t/g, "");
          text = text.split("Papara Üye Numarası")
          text = text[1].replace(/\t/g, "")
          text = text.split(" ")

          const paparaNo = text[0].trim()
          const tutar = text[1].replace("Tutar", "").trim()
          let ad = text[5] ? text[3].trim() + " " + text[4].trim() : text[3].trim()
          ad = ad.replace("Soyad", "").trim()
          const soyad =  text[5] ? text[5].trim() : text[4].trim()

          this.form.amount = tutar;
          this.form.name = `${ad} ${soyad}`;
          this.form.accountName = `${ad} ${soyad}`;
          this.form.iban = paparaNo;
          this.form.userId = paparaNo;
          this.form.userName = this.toSeoUrl(`${ad} ${soyad}`);
        } catch (e) {
          console.log("parse error");
          this.form = {
            amount: null,
            userId: null,
            name: null,
            userName: null,
            accountName: null,
            iban: null,
          };
        }
      } else {
        this.form = {
          amount: null,
          userId: null,
          name: null,
          userName: null,
          accountName: null,
          iban: null,
        };
      }
    },
    toSeoUrl(textString) {
      textString = textString.replace(/ /g, "");
      textString = textString.replace(/</g, "");
      textString = textString.replace(/>/g, "");
      textString = textString.replace(/"/g, "");
      textString = textString.replace(/é/g, "");
      textString = textString.replace(/!/g, "");
      textString = textString.replace(/’/, "");
      textString = textString.replace(/£/, "");
      textString = textString.replace(/^/, "");
      textString = textString.replace(/#/, "");
      textString = textString.replace(/$/, "");
      textString = textString.replace(/\+/g, "");
      textString = textString.replace(/%/g, "");
      textString = textString.replace(/½/g, "");
      textString = textString.replace(/&/g, "");
      textString = textString.replace(/\//g, "");
      textString = textString.replace(/{/g, "");
      textString = textString.replace(/\(/g, "");
      textString = textString.replace(/\[/g, "");
      textString = textString.replace(/\)/g, "");
      textString = textString.replace(/]/g, "");
      textString = textString.replace(/=/g, "");
      textString = textString.replace(/}/g, "");
      textString = textString.replace(/\?/g, "");
      textString = textString.replace(/\*/g, "");
      textString = textString.replace(/@/g, "");
      textString = textString.replace(/€/g, "");
      textString = textString.replace(/~/g, "");
      textString = textString.replace(/æ/g, "");
      textString = textString.replace(/ß/g, "");
      textString = textString.replace(/;/g, "");
      textString = textString.replace(/,/g, "");
      textString = textString.replace(/`/g, "");
      textString = textString.replace(/|/g, "");
      textString = textString.replace(/\./g, "");
      textString = textString.replace(/:/g, "");
      textString = textString.replace(/İ/g, "i");
      textString = textString.replace(/I/g, "i");
      textString = textString.replace(/ı/g, "i");
      textString = textString.replace(/ğ/g, "g");
      textString = textString.replace(/Ğ/g, "g");
      textString = textString.replace(/ü/g, "u");
      textString = textString.replace(/Ü/g, "u");
      textString = textString.replace(/ş/g, "s");
      textString = textString.replace(/Ş/g, "s");
      textString = textString.replace(/ö/g, "o");
      textString = textString.replace(/Ö/g, "o");
      textString = textString.replace(/ç/g, "c");
      textString = textString.replace(/Ç/g, "c");
      textString = textString.replace(/–/g, "");
      textString = textString.replace(/—/g, "");
      textString = textString.replace(/—-/g, "");
      textString = textString.replace(/—-/g, "");
      return textString.toLowerCase();
    }
  },
  mounted() {
    if (this.user.role === 'site') {
      if (String(this.user._site) === '609a49a70d506c0018eb46ad') {
        this.extraBetMode = true;
      }
      if (String(this.user._site) === '633b42d22cdd1c00185815c5') {
        this.interMode = true;
      }
      getSite(String(this.user._site)).then((response) => {
        this.site.id = this.user._site;
        this.site.appKey = response.data.data.appKey;
        this.site.appSecret = response.data.data.appSecret;
        this.site.skip2FaForTransaction = response.data.data.skip2FaForTransaction;
        this.setProcessId();
      });
    } else {
      getSites({page: 1, limit: 1000}).then((response) => {
        this.sites = response.data.data.docs;
        this.setProcessId();
      });
    }

  },
  watch: {
    selectedSite(val) {
      const find = this.sites.filter((s) => s._id === val);
      if (find.length > 0) {
        this.site.id = val;
        this.site.appKey = find[0].appKey;
        this.site.appSecret = find[0].appSecret;
        this.site.skip2FaForTransaction = find[0].skip2FaForTransaction;
      }
    },
    parseInput(val) {
      this.parseText();
    },
    parseInputInter(val) {
      this.parseTextInter();
    }
  }
};

</script>
<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <Loading v-if="loading"/>
          <div class="card-body">
            <form @submit.prevent="handleCreateWithdraw">

              <template v-if="extraBetMode">
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-group mb-2">
                      <input type="text" placeholder="₺000.00  Papara Isim Soyisim:Ad soyad, Papara Numarasi:1111111111" v-model="parseInput" class="form-control" />
                    </div>
                  </div>
                </div>
                <hr>
              </template>

              <template v-if="interMode">
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-group mb-2">
                      <input type="text" placeholder="Papara Üye Numarası	********** Tutar	1500 Ad Soyad	Ü*** A****" v-model="parseInputInter" class="form-control" />
                    </div>
                  </div>
                </div>
                <hr>
              </template>

              <div class="row">
                <div v-if="user.role === 'root'" class="col-12">
                  <div class="form-group mb-2">
                    <label class="col-form-label">Site</label>
                    <select class="form-control custom-select" v-model="selectedSite">
                      <option v-for="site in sites" :key="site._id" :value="site._id">{{ site.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="name" class="col-form-label">Ad & Soyad</label>
                    <input v-validate="'required'" id="name" name="name" v-model="form.name" type="text" :readonly="extraBetMode"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('name', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="userName" class="col-form-label">Kullanıcı Adı</label>
                    <input v-validate="'required'" id="userName" name="userName" v-model="form.userName" type="text" :readonly="extraBetMode"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('userName', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="userId" class="col-form-label">Kullanıcı ID</label>
                    <input v-validate="'required'" id="userId" name="userId" v-model="form.userId" type="text" :readonly="extraBetMode"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('userId', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="accountName" class="col-form-label">Hesap Adı</label>
                    <input v-validate="'required'" id="accountName" name="accountName" v-model="form.accountName" :readonly="extraBetMode"
                           type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('accountName', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="iban" class="col-form-label">IBAN</label>
                    <input v-validate="'required'" id="iban" name="accountName" v-model="form.iban" type="text" :readonly="extraBetMode"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('iban', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="amount" class="col-form-label">Tutar</label>
                    <input v-validate="'required'" id="amount" name="accountName" v-model="form.amount" type="number" :readonly="extraBetMode"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('amount', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

              </div>
              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-primary">Talebi gönder</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="twofa-modal" hide-footer title="İki adımlı doğrulama">
      <div role="tablist">
        <b-card no-body class="mb-1">
          <b-card-body>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-2">
                  <label for="twoFaKey" class="col-form-label">Doğrulama Kodu</label>
                  <b-input-group>
                    <input id="twoFaKey" v-model="twoFaKey" type="text" class="form-control"/>
                  </b-input-group>
                </div>
              </div>
              <div class="col-md-12">
                <b-button @click="validateTwoFactor()" size="sm" variant="success">Doğrula</b-button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>

  </div>
</template>
